import animateScrollTo from 'animated-scroll-to';
import {get} from 'lodash'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    props: {
        curQuestionPath: {
            type: Object,
            required: true,
        }
    },
    data: () => ({
        tabPrefix: 'tab-',
        questionPrefix: 'question-',
        localQuestionPath: {}
    }),
    computed: {
        self() {
            return this;
        },
    },
    methods: {
        updateCurrentQuestionPath(questionPath) {
            const parts = ['category', 'question']
                .map(key => get(questionPath, key))
                .filter(value => value);

            if(parts.length === 0) {
                return;
            }

            this.localQuestionPath = {...questionPath};
            window.location.hash = '#' + parts.join('/');
        },
        onOpenTabClick: function(event) {
            const tab = event.target;
            this.openTab(tab);

            const category = tab.attributes['data-page'].nodeValue;
            this.updateCurrentQuestionPath({category});
        },
        openTab(tab) {
            if(!tab) {
                return;
            }

            Array.from(tab.parentNode.parentNode.children).forEach((e) => {
                e.classList.remove('active');
            });
            tab.parentNode.classList.add('active');
            document.querySelectorAll('.data .tab').forEach((e) => {e.classList.remove('active')});
            document.querySelectorAll('.data .tab[data-page="' + tab.attributes['data-page'].nodeValue + '"]')[0].classList.add('active');
        },
        onToggleClick: function(event){
            const questionNode = event.target;
            this.toggleQuestion(questionNode);

            const question = questionNode.attributes['data-question'].nodeValue;
            this.updateCurrentQuestionPath({...this.localQuestionPath, question});
        },
        toggleQuestion(question) {
            question.parentNode.classList.toggle('open');
        },
        showDefault: function(el){
            let element = el.target;
            Array.from(element.parentNode.parentNode.parentNode.children).forEach((e) => {
                e.removeAttribute('style');
            });
            element.parentNode.parentNode.setAttribute("style", "display: none;");
        },
        toggleEl: function(id){
            let el = document.getElementById(id);
            el.classList.toggle('open');
            setTimeout(()=>{
                animateScrollTo(el);
            }, 0);

        },
        scrollTo: function(id){
            let element = document.getElementById(id);
            animateScrollTo(element)
        },
        openQuestion(questionPath) {
            if (!questionPath) {
                return;
            }

            const category = get(questionPath, 'category');
            const question = get(questionPath, 'question');

            const categoryRef = this.tabPrefix + category;
            if (!category || !this.hasRef(categoryRef)) {
                return;
            }

            this.openTab(this.$refs[categoryRef]);

            const questionRef = this.questionPrefix + question;
            if (!question || !this.hasRef(questionRef)) {
                return;
            }

            this.toggleQuestion(this.$refs[questionRef]);
            animateScrollTo(this.$refs[questionRef], {verticalOffset: 100})
        },
        hasRef(ref) {
            return Object.keys(this.$refs).includes(ref);
        },
        /**
         * @param hash - hash в url с путём до вопроса: #category/question, например, #common/about-kei
         * @return {{question: (*|string), category: (*|string)}|null}
         */
        parseQuestionHash(hash) {
            if (!hash) {
                return null;
            }
            const [category, question] = hash.slice(1).split('/')
            return {category, question};
        }
    },
    mounted() {
        const questionPath = this.parseQuestionHash(window.location.hash);
        this.updateCurrentQuestionPath(questionPath);
        this.openQuestion(questionPath);
        this.localQuestionPath = this.curQuestionPath;
    }
}
